import { render, staticRenderFns } from "./artist.vue?vue&type=template&id=3f5e6070&scoped=true"
import script from "./artist.vue?vue&type=script&lang=js"
export * from "./artist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e6070",
  null
  
)

export default component.exports